module.exports = __webpack_public_path__ + "images/Beyond_Blue_logo.svg";